import { useState } from "react";

/**
 * Hook para validación de formularios
 * Maneja validación de email, teléfono, checkbox y token de Turnstile
 */
const useFormValidation = () => {
    // Estados de validación
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [invalidPhoneNumber, setInvalidPhoneNumber] = useState(false);
    const [invalidFirstName, setInvalidFirstName] = useState(false);
    const [invalidLastName, setInvalidLastName] = useState(false);
    const [invalidCompanyName, setInvalidCompanyName] = useState(false);
    const [checkboxValue, setCheckboxValue] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState(false);

    // Expresiones regulares para validación
    const rexEmail =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const rexPhoneNumber = /^[\+]?[(]?[0-9]{8,12}[)]?$/;
    // Permite letras (incluyendo acentos), espacios y guiones
    // Requiere al menos 2 letras en total
    const rexName = /^(?=.*[a-záéíóúñüA-ZÁÉÍÓÚÑÜ].*[a-záéíóúñüA-ZÁÉÍÓÚÑÜ])[a-záéíóúñüA-ZÁÉÍÓÚÑÜ\s\-]+$/;

    // Valida formato de email
    const validateEmail = (email) => {
        setInvalidEmail(!rexEmail.test(email));
    };

    // Valida formato de número telefónico
    const validatePhoneNumber = (phoneNumber) => {
        setInvalidPhoneNumber(!rexPhoneNumber.test(phoneNumber));
    };

    // Valida formato de nombre (mínimo 2 letras, permite guiones y espacios)
    const validateName = (name, field = "first_name") => {
        const trimmedName = name.trim();
        const isValid = trimmedName.length > 0 && rexName.test(trimmedName);
        
        if (field === "first_name") {
            setInvalidFirstName(!isValid);
        } else if (field === "last_name") {
            setInvalidLastName(!isValid);
        } else if (field === "company_name") {
            setInvalidCompanyName(!isValid);
        }
        
        return isValid;
    };

    // Limpia caracteres de máscara de input
    const cleanMask = (value) => {
        return value.replace("$", "").replaceAll(".", "").replaceAll("-", "").replaceAll("_", "");
    };

    // Maneja cambios en checkbox
    const handleCheckboxChange = (e) => {
        setCheckboxValue(e.target.checked);
    };

    // Maneja envío de token de Turnstile para verificación
    const handleTokenSubmit = (token) => {
        fetch("/recaptcha/", {
            method: "POST",
            body: JSON.stringify({ token: token }),
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": document.querySelector('meta[name ="csrf-token"]').content,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setTurnstileToken(true);
                }
            })
            .catch((error) => {
                console.log("ERROR", error);
            });
    };

    return {
        invalidEmail,
        invalidPhoneNumber,
        invalidFirstName,
        invalidLastName,
        invalidCompanyName,
        checkboxValue,
        turnstileToken,
        validateEmail,
        validatePhoneNumber,
        validateName,
        cleanMask,
        handleCheckboxChange,
        handleTokenSubmit
    };
};

export default useFormValidation;